import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { Select } from 'antd';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { useCallback, useMemo } from 'react';
import { SelectOption } from 'types/base';

const Hardware = ({
  control,
  index,
  required,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  required?: boolean;
}) => {
  const { hardwareSelectOptions } = useAppSelector(selectGlobalInfo);
  const hardwareListSort = useMemo((): SelectOption[] => {
    if (hardwareSelectOptions && hardwareSelectOptions.length) {
      return [...hardwareSelectOptions].sort(
        (a: SelectOption, b: SelectOption) => b.sort! - a.sort!
      );
    }
    return [];
  }, [hardwareSelectOptions]);

  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );

  return (
    <div className="flex items-center gap-2">
      <FormLabel required={required}>{i18n.t(LOCALS.hardware)}:</FormLabel>
      <Controller
        name={`productList.${index}.hardware`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Select
            {...field}
            className="w-full"
            mode="multiple"
            status={errors.productList?.[index]?.hardware ? 'error' : undefined}
            options={hardwareListSort}
            showSearch
            filterOption={SelectFilter}
            placeholder={i18n.t(LOCALS.please_select) || ''}
            allowClear
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        )}
      />
    </div>
  );
};

export default Hardware;
